export default {
  loading: {
    text: "Loading...",
  },
  filters: {
    time: "Time",
    startDate: "Start Date",
    endDate: "End Date",
    addressSearch: "Address Search",
    searchCounterpartyAddress: "Search counterparty address",
    currency: "Currency",
    selectCurrency: "Select currency",
    amount: "Amount",
    minAmount: "Min amount",
    maxAmount: "Max amount",
    maxAmountError: "Minimum amount cannot exceed maximum amount",
    hideZeroTransactions: "Hide zero-amount transactions",
  },
  actions: {
    reset: "Reset",
    query: "Search",
  },
  table: {
    totalPrefix: "Total ",
    totalSuffix: " records",
    download: "Download",
    empty: "No data",
    bigAddressEmpty: "Too much data for this address, please filter first",
    transactionHash: "Transaction Hash",
    sender: "Sender",
    receiver: "Receiver",
    currency: "Currency",
    transactionAmount: "Amount",
    transactionTime: "Time",
  },
  directionOptions: {
    ALL: "All",
    SENDER: "Sender",
    RECEIVER: "Receiver",
  },
};
